import { createApi } from "@reduxjs/toolkit/query/react"
import { addAdminTokenInHeaders } from "../customFetchBaseQuery";

export const apiAdminSlice = createApi({
    reducerPath: "api-admin",
    baseQuery: addAdminTokenInHeaders,
    endpoints: builder => {
        return {
            adminLogin: builder.mutation({
                query: ({ username, password }) => ({
                    url: `/api/admin/login`,
                    method: 'POST',
                    body: { username, password },
                })
            }),
            getAllApnList: builder.mutation({
                query: () => ({
                    url: `/api/admin/apn/pending`,
                    method: 'GET'
                })
            }),
            updateApnFile: builder.mutation({
                query: ({ apnId, body }: { apnId: string, body: { status: string, comments: string } }) => ({
                    // url: `/api/admin/apn/${apnId}`,
                    url: `/api/admin/apn/update/${apnId}`,
                    method: 'POST',
                    body
                })
            }),
            downloadApnFile: builder.mutation({
                query: (fileName: string) => ({
                    url: `/api/admin/apn/pending/${fileName}`,
                    method: 'GET',
                })
            }),
            // Vendors (July F5) — the pending-vendors queue + approve/reject.
            getVendors: builder.query({
                query: (status?: string) => ({
                    url: status
                        ? `/api/admin/vendors?status=${encodeURIComponent(status)}`
                        : `/api/admin/vendors`,
                    method: 'GET',
                })
            }),
            approveVendor: builder.mutation({
                query: (vendorId: string) => ({
                    url: `/api/admin/vendor/${vendorId}/approve`,
                    method: 'PATCH',
                    body: {},
                })
            }),
            rejectVendor: builder.mutation({
                query: ({ vendorId, reason }: { vendorId: string; reason: string }) => ({
                    url: `/api/admin/vendor/${vendorId}/reject`,
                    method: 'PATCH',
                    body: { reason },
                })
            })
        }
    }
})


export const {
    useAdminLoginMutation,
    useGetAllApnListMutation,
    useUpdateApnFileMutation,
    useDownloadApnFileMutation,
    useGetVendorsQuery,
    useApproveVendorMutation,
    useRejectVendorMutation,
} = apiAdminSlice;
